import { render, staticRenderFns } from "./medics-form.vue?vue&type=template&id=60178d51&"
import script from "./medics-form.vue?vue&type=script&lang=js&"
export * from "./medics-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports